import React from 'react'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../../templates/PrivatePageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import DocumentsCollectSF from '../../../components/finapp/account/DocumentsCollectSF'

const LoanDetailPageUI = ({context, errorList, loan}) =>
  <PrivatePageSF context={context} className='pg_loan' centered={!loan && !errorList}>
    {
      !loan && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <React.Fragment>
        {(() => {
            switch(loan.status) {
              case 'requested':
                return <DocumentsCollectSF context={context} />
              default:
                return <span>bbb</span>
            }
        })()}
      </React.Fragment>
    }
  </PrivatePageSF>

export default LoanDetailPageUI
